import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';
//import * as XLSX from "xlsx";

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
  respObject: any;
  data=[];
  hasError: boolean = false;
  loaderVisibility: boolean = false;
  dataType = "";
  fileYear="";
  fullYear: number = new Date().getFullYear();
  yearArr= [];
  yearfArr= [];
  filefYear="";
  peerId = '';
  selectMonth="";
  fileQuarter="";
  errMsg= [];
  downLoadPath = this._rest.FILE_PATH;
  monthArr = ["January","February","March","April","May","June","July","August","September","October","November","December"]
  segmentLockDate=0;
  
  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(){
    // var files = <HTMLInputElement>document.getElementById('file-multiple-input');
    // console.log(files);
    this.dataType = "Segment";
    // this.selectMonth="January";
    this.selectMonth =  this.monthArr [new Date().getMonth() -1 ];
    this.fileQuarter="Q1";
  	//const userId = localStorage.getItem('userId');
  	//const companyId = localStorage.getItem('companyId');
    // this.peerId = localStorage.getItem('peerId');
    for (var i= this.fullYear-4;i<=this.fullYear;i++){
      this.yearArr.push(i);
      this.fileYear= i+"";
    }
    for (var i= this.fullYear-4;i<=this.fullYear;i++){
      this.yearfArr.push(i+"-"+(i+1));
      this.filefYear = i+"-"+(i+1);
    }

    this.loaderVisibility=false;
      
  }

  refresh(): void {
    // this.dataType="Segment";
    // console.log(window.location);
    // window.location.reload();
    // var fileuploadPath = 'analyst/fileupload';
    
    // this.router.navigate([fileuploadPath]);
    this.router.navigate(['/analyst']).then(()=>{
      // do whatever you need after navigation succeeds
      this.router.navigate(['/analyst/fileupload']);
    });
    
    // this.respObject: any;
    // this.ngOnInit();
  }
  downloadFile(file){

  }
  uploadFile(){
    
    this.hasError = false;
    var errCounter  = 0;
    this.loaderVisibility=true;
  	const userId = localStorage.getItem('userId');
  	const companyId = localStorage.getItem('companyId');
  	this.errMsg= [];
    
    
    const fd = new FormData();
    const fd1 = {};
    fd.append('userId', userId);
    fd1["userId"]=userId;
    fd.append('companyId', companyId);
    fd1["companyId"]=companyId;
    fd.append('templateType', this.dataType);
    fd1["templateType"] = this.dataType;
   
    //console.log('Testing');
    //console.log(files.files[0]);
    
    if(this.dataType == "Segment"){
      if(this.selectMonth == ""){
        errCounter++;
        this.errMsg.push("Please select Month.");
      } else {                
        fd.append('templateId','1');
        fd.append('year',this.fileYear);
        fd1["year"] = this.fileYear;
        fd.append('monthly',this.selectMonth);
        fd1["monthly"] = this.selectMonth;
      }
    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){
      if(this.fileQuarter == ""){
        errCounter++;
        this.errMsg.push("Please select Quarter.");
      } else {
        if(this.dataType == "Form"){
          fd.append('templateId','2');
        } else if(this.dataType == "Data on Motor"){
          fd.append('templateId','17');
        } else if(this.dataType == "Financial Highlights"){
          fd.append('templateId','24');
        } else if(this.dataType == "Reinsurance"){
          fd.append('templateId','25');
        } 
        //  else if(this.dataType == "MotorPremium"){
        //   fd.append('templateId','26');
        // }    
        fd.append('year',this.filefYear);
        fd.append('quarterly',this.fileQuarter);
        fd1["year"] = this.filefYear;
        fd1["quarterly"] = this.fileQuarter;
      }
    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){
      if(this.dataType == "Gross & Net Statistics"){
        fd.append('templateId','12');
      } else {
        fd.append('templateId','13');
      }      
      fd.append('year',this.filefYear);
      fd1["year"] = this.filefYear;
    }
    var files = <HTMLInputElement>document.getElementById('file-multiple-input');
    /* if (files.files[0]!= undefined && (files.files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
     files.files[0].type === 'application/vnd.ms-excel')) {
      fd.append('file', files.files[0]);
    } else {
      errCounter++;
      this.errMsg.push("Please select valid excel file.");
    }*/
    if (files.files[0]!= undefined) {
      fd.append('file', files.files[0]);
    } else {
      errCounter++;
      this.errMsg.push("Please select valid excel file.");
    }
    if(errCounter==0){
      this._rest.checkFileConfig(fd1).subscribe((res) => {
        this.respObject = res;
        if(this.respObject.error==0){
          this._rest.uplpadData(fd).subscribe((res) => {
            this.respObject = res;
            console.log(JSON.stringify(res))
            if (this.respObject.resp.err === undefined) {
              //alert(this.respObject.resp.message);
              this.loaderVisibility=false;
              if(this.respObject.resp.message=="upload successful"){
                alert("The file is successfully uploaded.");
                this.refresh();
              } else {
                this.errMsg.push(this.respObject.resp.message);
                this.hasError = true;
                this.loaderVisibility=false;
              }
            } else {
              
              for(var i=0;i<this.respObject.resp.err.length;i++){
                this.errMsg.push(this.respObject.resp.err[i]);
              }
              this.hasError = true;
              this.loaderVisibility=false;
            }
          });
        } else {
          this.errMsg.push(this.respObject.errorMessage);
          this.hasError = true;
          this.loaderVisibility=false;
        }
      });
    } else {
      this.hasError = true;
      this.loaderVisibility=false;
    }
  }
  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

}
